
import Vue, { PropType } from 'vue';
import { Assessment, Variant } from '@/models/greathall/assessment.model';
import { Icon, Modal, FileUploadBox } from '@descomplica/vue-components';
import i18n from '@/i18n';
import { TranslateResult } from 'vue-i18n';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { MAX_ALLOWED_FILESIZE } from '@/helpers/upload';

interface Data {
  isActive: boolean;
  maxFileSize: number;
  isUploadReady: boolean;
  file: {
    name: string;
    dataUrl: string;
  };
  errorMessage: TranslateResult;
  showSendErrorMessage: boolean;
}

export default Vue.extend({
  components: {
    Icon,
    Modal,
    FileUploadBox,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    assessment: {
      type: Object as PropType<Assessment>,
      required: true,
    },
  },
  data(): Data {
    return {
      isActive: this.active,
      maxFileSize: MAX_ALLOWED_FILESIZE,
      isUploadReady: false,
      file: {
        name: '',
        dataUrl: '',
      },
      errorMessage: '',
      showSendErrorMessage: false,
    };
  },
  computed: {
    borderRadius(): number {
      return this.getBorderRadius(window.innerWidth);
    },
    variant(): Variant {
      return this.assessment.currentVariantByUser;
    },
    getInstructions(): TranslateResult {
      return !this.assessment.instructions
        ? i18n.t('yourAssessments.module2.about')
        : this.assessment.instructions;
    },
  },
  watch: {
    active(value) {
      this.isActive = value;
    },
  },
  methods: {
    getBorderRadius(width: number): number {
      if (width > 495) return 24;
      return 0;
    },
    updateActive(active: boolean) {
      this.$emit('update:active', active);
    },
    onCloseClick() {
      this.updateActive(false);
    },
    documentDeleteHandler() {
      this.showSendErrorMessage = false;
      this.file.name = '';
      this.file.dataUrl = '';
      this.errorMessage = '';
      this.isUploadReady = false;
    },
    documentUploadHandler(file: File) {
      this.showSendErrorMessage = false;
      this.errorMessage = '';
      this.file.name = file.name;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.file.dataUrl = reader.result as string;
      };

      this.isUploadReady = true;
    },
    errorHandler(error: 'type' | 'size') {
      this.errorMessage = i18n.t(`yourAssessments.module2.uploadError.${error}`);
    },

    async sendAssessmentReply() {
      if (this.isUploadReady) {
        this.showSendErrorMessage = false;
        const dexCourseId = this.$store.getters.currentCourse.id;

        const replyData = {
          dexCourseId,
          data: {
            fileName: this.file.name,
            dataUrl: this.file.dataUrl,
            variantId: this.variant.id,
            assessmentId: this.assessment.id,
          },
        };

        try {
          await this.$store.dispatch('SEND_ASSESSMENT_REPLY_FILE', replyData);
          this.onCloseClick();
        } catch (error) {
          this.showSendErrorMessage = true;
        }

        if (!this.showSendErrorMessage) {
          this.$store.dispatch('PULL_MINIMUM_ASSESSMENT_DATA', { dexCourseId });
          Analytics.trackEvent(EVENT_LABELS.studyCaseSent, {
            relatedAssessmentCategory: this.assessment.category?.name || '',
          });
        }
      }
    },
  },
});
